import { render } from "./FilesList.vue?vue&type=template&id=3ce4722c&scoped=true"
import script from "./FilesList.vue?vue&type=script&lang=js"
export * from "./FilesList.vue?vue&type=script&lang=js"

import "./FilesList.vue?vue&type=style&index=0&id=3ce4722c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce4722c"]])

export default __exports__